import { DropdownButton, DropdownButtonType, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import { DataQualityTriggerConfigurationUIAction, DataQualityTriggerConfigurationUIProps } from '~src/app/quality/DataQualityTriggerDialog';
import { DataQualityTriggerUberDialog } from '~src/app/quality/DataQualityTriggerUberDialog';
import { Messages } from '../../codegen/Localize';
import { LinkedTaskFlowState } from '../state/LinkedTaskStateTypes';
import { LinkedTaskDeleteTaskButton } from './LinkedTaskDeleteTaskButton';
import { LinkedTaskOptionCheckboxItem, LinkedTaskOptionCheckboxList } from './LinkedTaskOptionCheckboxList';

const wrapperStyle = style({
  padding: `${TabStyles.Spacing.DefaultSpace}px ${TabStyles.Spacing.MediumSpace}px`,
});

const optionColumnStyle = style({
  display: 'flex',
  marginTop: 16,
});

export interface FlowLinkedTaskOptionsProps {
  index: number;
  dispatch: React.Dispatch<FlowLinkedTaskOptionsAction>;
  flowLinkedTaskState: LinkedTaskFlowState;
}

export type FlowLinkedTaskOptionsAction =
  DataQualityTriggerConfigurationUIWithFlowIdAction |
  { type: 'setDqwEnabled', payload: { index: number, value: LinkedTaskFlowState['dqwEnabled']}} |
  { type: 'setStopRemainingTasks', payload: { index: number, value: LinkedTaskFlowState['stopRemainingTasks']}} |
  { type: 'deleteTaskEntry', value: number };

type DataQualityTriggerConfigurationUIWithFlowIdAction =
  { type: 'setEnableTrigger', payload: { index: number, value: DataQualityTriggerConfigurationUIProps['enableTrigger'] }} |
  { type: 'setIsSevere', payload: { index: number, value: DataQualityTriggerConfigurationUIProps['isSevere'] }} |
  { type: 'setMessage', payload: { index: number, value: DataQualityTriggerConfigurationUIProps['message'] }};

export function FlowLinkedTaskOptions(props: FlowLinkedTaskOptionsProps): JSX.Element {

  const [dialogId] = React.useState('1'); //TODO jjia: update this to use a unique id
  const [isOpen, setIsOpen] = React.useState(false);

  // Middle layer to convert DQW dispatch into Linked Task dispatch
  function dqwDispatch(action: DataQualityTriggerConfigurationUIAction) {
    // Linter does not like comparing the two action types here, using any to resolve
    // TODO: find typesafe typing for this action
    const updatedAction: any = {
      type: action.type,
      payload: {
        index: props.index,
        value: action.value
      }
    };
    props.dispatch(updatedAction);
  }

  const dataQualityDialogProps = {
    contentType: 'flow',
    enableTrigger: props.flowLinkedTaskState.dqw.enableTrigger,
    isSevere: props.flowLinkedTaskState.dqw.isSevere,
    message: props.flowLinkedTaskState.dqw.message,
    dispatch: dqwDispatch,
  };

  const succeedOptionItems: LinkedTaskOptionCheckboxItem[] = [{
    label: Messages.linkedTasksStartNextTask(),
    isMandatory: true,
  }];
  const failureOptionItems: LinkedTaskOptionCheckboxItem[] = [{
    label: Messages.linkedTasksAddDataQualityWarning(),
    isChecked: props.flowLinkedTaskState.dqwEnabled,
    handleClick: (value) => props.dispatch({ type: 'setDqwEnabled', payload: { index: props.index, value }}),
    actionComponent: <DataQualityTriggerUberDialog {...dataQualityDialogProps} />,
  }, {
    label: Messages.linkedTasksStopRemainingTasks(),
    isChecked: props.flowLinkedTaskState.stopRemainingTasks,
    handleClick: (value) => props.dispatch({ type: 'setStopRemainingTasks', payload: { index: props.index, value }}),
  }, {
    label: Messages.linkedTasksEmailMe(),
    isMandatory: true,
  }];

  function onDelete() {
    props.dispatch({type: 'deleteTaskEntry', value: props.index});
  }
  const deleteTaskButtonProps = {
    id: props.flowLinkedTaskState.flowId,
    onDelete: onDelete,
    style: {
      display: 'flex',
      marginLeft: 'auto',
    },
  };

  return (
    <div className={wrapperStyle}>
      <DropdownButton
        label={Messages.linkedTasksOptions()}
        aria-controls={dialogId}
        aria-haspopup='dialog'
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        popupContent={<div role='dialog'>{`TODO: Add dialog here`}</div>}
        testId={`FlowLinkedTaskOptions-${dialogId}`}
        type={DropdownButtonType.Outline}
      >{`Select Outputs`}</DropdownButton>
      <div className={optionColumnStyle}>
        <LinkedTaskOptionCheckboxList type={'succeed'} items={succeedOptionItems}/>
        <LinkedTaskOptionCheckboxList type={'fail'} items={failureOptionItems}/>
      </div>
      <LinkedTaskDeleteTaskButton {...deleteTaskButtonProps}/>
    </div>
  );
}